import { useAppSelector, useAppDispatch } from '@common/hooks'
import { usePostHog } from 'posthog-js/react'
import { completeExitSurvey, dismissExitSurvey } from '@features/surveys/surveys.slice'
import { useEffect } from 'react'
import { SurveyModal } from './survey-modal'
import { useState } from 'react'
import { ENABLE_ANALYTICS } from '@config'
import {
  useModulesSubmitModuleResultMutation,
  useLazyModulesGetUserModulesQuery,
} from '@app/services/auto-generated/modules'

export const TestSurvey: React.FC = () => {
  const dispatch = useAppDispatch()
  const shouldShow = useAppSelector((state) => state.surveys.shouldShowExitSurvey)
  const [surveyTitle, setSurveyTitle] = useState('')
  const [surveyId, setSurveyId] = useState('')
  const [submit] = useModulesSubmitModuleResultMutation()
  const [getModules] = useLazyModulesGetUserModulesQuery()

  const survey = useAppSelector((state) => state.surveys.exitSurvey)
  const posthog = usePostHog()

  useEffect(() => {
    const checkModules = async () => {
      if (!shouldShow) return null
      try {
        const response = await getModules().unwrap()
        console.log('Response:', response.submitted)
        if (response.submitted.includes('SurveyDisplayModule')) {
          // If module exists, dismiss survey
          console.log('Module exists, dismissing survey')
          dispatch(dismissExitSurvey({ surveyId }))
        } else {
          // Only fetch survey if module not submitted
          if (ENABLE_ANALYTICS && posthog) {
            posthog.getSurveys((surveys) => {
              if (surveys && surveys.length > 0) {
                const survey = surveys[0]
                if (survey.questions && survey.questions.length > 0) {
                  setSurveyTitle(survey.questions[0].question)
                  setSurveyId(survey.id)
                }
              }
            })
          }
        }
      } catch (error) {
        console.error('Failed to fetch modules:', error)
      }
    }

    if (shouldShow) {
      checkModules()
    }
  }, [shouldShow, posthog, dispatch, surveyId, getModules])

  const handleSurveySubmit = async (value: string) => {
    try {
      // Submit the survey response
      dispatch(completeExitSurvey({ surveyId, surveyValue: value }))

      // Mark the module as completed
      await submit({
        moduleResult: {
          id: 'SurveyDisplayModule',
          data: { completed: true },
        },
      }).unwrap()
    } catch (error) {
      console.error('Failed to submit module result:', error)
    }
  }

  if (!shouldShow) {
    return null
  }

  return (
    <SurveyModal
      question={surveyTitle}
      onClose={() => dispatch(dismissExitSurvey({ surveyId }))}
      onSubmit={handleSurveySubmit}
    />
  )
}
